import styled from '@emotion/styled';
import { fonts, space } from 'folio-common-components';

export const DefList = styled.dl`
  margin: 0;
`;

export const DefTitle = styled.dt`
  color: var(--muted-color);
  margin-bottom: 4px;
`;

export const DefData = styled.dd`
  ${fonts.font300book};
  margin: 0;

  &:not(:last-of-type) {
    ${space([24], 'margin-bottom')};
  }
`;
